import { render, staticRenderFns } from "./campaignHeader.vue?vue&type=template&id=894ed4cc&"
import script from "./campaignHeader.vue?vue&type=script&lang=js&"
export * from "./campaignHeader.vue?vue&type=script&lang=js&"
import style0 from "./campaignHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports